import {
  ApiBlueprint,
  PageBlueprint,
  createApiFactory,
  createFrontendPlugin,
  createRouteRef,
} from '@backstage/frontend-plugin-api';
import { configApiRef, identityApiRef } from '@backstage/core-plugin-api';
import { infraWalletApiRef } from './api/InfraWalletApi';
import { InfraWalletApiClient } from './api/InfraWalletApiClient';

export const infraWalletRouteRef = createRouteRef();

const infraWalletApi = ApiBlueprint.make({
  name: 'infrawallet',
  params: define =>
    define(
      createApiFactory({
        api: infraWalletApiRef,
        deps: { identityApi: identityApiRef, configApi: configApiRef },
        factory: ({ identityApi, configApi }) =>
          new InfraWalletApiClient({ identityApi, configApi }),
      }),
    ),
});

const infraWalletPage = PageBlueprint.make({
  params: {
    path: '/infrawallet',
    noHeader: true,
    routeRef: infraWalletRouteRef,
    loader: () =>
      import('./components/Router').then(m => <m.Router />),
  },
});

export default createFrontendPlugin({
  pluginId: 'infrawallet',
  extensions: [infraWalletApi, infraWalletPage],
});
